import * as Sentry from "@sentry/react";
import { SHOP_SUBSCRIPTION_URL } from "../constants/endpoints";
import axiosClient from "./axios";

class FetchShopSubscriptionService {
  static async fetchShopSubscription(shopId: string) {
    const url = SHOP_SUBSCRIPTION_URL.replace("{shopId}", shopId);

    return Sentry.startSpan(
      {
        op: "http.client",
        name: "GET /admin/chargeAtWill/subscription/{shopId}",
      },
      async () => {
        return axiosClient.get(url, {
          // A shop with no subscription yet is answered with a 404. That is a
          // normal state here, not a failure, so it is treated as a valid
          // response: otherwise the global response interceptor would fire a
          // "Not found" toast at every shop that hasn't subscribed. Callers
          // detect it via the absence of `result.data`.
          validateStatus: (status) => status === 200 || status === 404,
        });
      }
    );
  }
}

export default FetchShopSubscriptionService;
